export const EMPLOYEE_OPERATION_START = 'EMPLOYEE_OPERATION_START';
export const EMPLOYEE_OPERATION_END = 'EMPLOYEE_OPERATION_END';
export const EMPLOYEE_CLEAR_ERROR = 'EMPLOYEE_CLEAR_ERROR';
export const UPDATE_EMPLOYEE_FORM = 'UPDATE_EMPLOYEE_FORM';
export const CHANGE_EMPLOYEE_WORKFLOW_STEP = 'CHANGE_EMPLOYEE_WORKFLOW_STEP';
export const DISCARD_EMPLOYEE_APPLICATION = 'DISCARD_EMPLOYEE_APPLICATION';
export const ADD_TO_EMPLOYEE_ERROR = 'ADD_TO_EMPLOYEE_ERROR';

export const INITIATE_EMPLOYEE_APPLICATION = 'INITIATE_EMPLOYEE_APPLICATION';
export const FETCH_EMPLOYEE_USER = 'FETCH_EMPLOYEE_USER';
export const SAVE_EMPLOYEE_INFO = 'SAVE_EMPLOYEE_INFO';
export const ADD_EMPLOYEE_PROPERTIES = 'ADD_EMPLOYEE_PROPERTIES';
export const REMOVE_EMPLOYEE_PROPERY = 'REMOVE_EMPLOYEE_PROPERY';
export const FETCH_EMPLOYEE_PERMISSIONS = 'FETCH_EMPLOYEE_PERMISSIONS';
export const SAVE_EMPLOYEE_PERMISSIONS = 'SAVE_EMPLOYEE_PERMISSIONS';
export const UPLOAD_EMPLOYEE_DOCUMENT = 'UPLOAD_EMPLOYEE_DOCUMENT';
export const DELETE_EMPLOYEE_DOCUMENT = 'DELETE_EMPLOYEE_DOCUMENT';
export const FETCH_EMPLOYEE_APPLICATION = 'FETCH_EMPLOYEE_APPLICATION';
export const DOWNLOAD_EMPLOYE_DOCUMENT = 'DOWNLOAD_EMPLOYE_DOCUMENT';
export const CHECKOUT_EMPLOYE_FORM = 'CHECKOUT_EMPLOYE_FORM';

export const FETCH_EMPLOYEE_LIST = 'FETCH_EMPLOYEE_LIST';
export const FETCH_EMPLOYEE_LIST_SUCCESS = 'FETCH_EMPLOYEE_LIST_SUCCESS';
export const FETCH_EMPLOYEE_LIST_ERROR = 'FETCH_EMPLOYEE_LIST_ERROR';

export const SEARCH_EMPLOYEE_LIST = 'SEARCH_EMPLOYEE_LIST';
export const SEARCH_EMPLOYEE_LIST_SUCCESS = 'SEARCH_EMPLOYEE_LIST_SUCCESS';
export const SEARCH_EMPLOYEE_LIST_ERROR = 'SEARCH_EMPLOYEE_LIST_ERROR';

export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';

export const FETCH_EMPLOYEE_DETAIL_SUCCESS = 'FETCH_EMPLOYEE_DETAIL_SUCCESS';

export const FINAL_EMPLOYEE_SAVE_SUCCESS = 'FINAL_EMPLOYEE_SAVE_SUCCESS';

export const FETCH_EMPLOYEE_PROPERTIES_SUCCESS = 'FETCH_EMPLOYEE_PROPERTIES_SUCCESS';

export const EDIT_SUCCESS_FALSE = 'EDIT_SUCCESS_FALSE';
export const DEACTIVATE_EMPLOYEE_SUCCESS = 'DEACTIVATE_EMPLOYEE_SUCCESS';
export const REACTIVATE_EMPLOYEE_SUCCESS = 'REACTIVATE_EMPLOYEE_SUCCESS';

export const UPDATE_SELECTED_PERMISSION = 'UPDATE_SELECTED_PERMISSION';

export const UPDATE_EMPLOYEE_DETAIL = 'UPDATE_EMPLOYEE_DETAIL';
